import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

interface SignInButtonProps {
    onClick: () => void
    t: (key: string) => string
    variant: 'flyin' | 'cleartrip' | 'mobile'
    hidden?: boolean
}

const SignInButton: React.FC<SignInButtonProps> = ({ onClick, t, variant, hidden = false }) => {
    if (hidden) return null

    if (variant === 'flyin') {
        return (
            <Link
                href="#"
                underline="none"
                sx={{
                    display: { xs: 'none', sm: 'none', md: 'inline' },
                    color: '#1a2a3a',
                    fontWeight: 500,
                    fontSize: 14,
                    ml: 0.7,
                    cursor: 'pointer',
                    '&:hover': { color: '#194E91' }
                }}
                onClick={e => {
                    e.preventDefault()
                    onClick()
                }}
            >
                {t('signIn')}
            </Link>
        )
    }

    if (variant === 'mobile') {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '50px',
                    border: '1px solid',
                    borderColor: 'primary.main',
                    bgcolor: 'background.paper',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': {
                        bgcolor: 'primary.lighter',
                        borderColor: 'primary.dark'
                    }
                }}
                onClick={onClick}
            >
                <PersonOutlineIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        color: 'primary.main'
                    }}
                >
                    {t('signIn')}
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                gap: 0.5,
                px: 1.5,
                py: 0.75,
                borderRadius: 1,
                '&:hover': {
                    bgcolor: 'primary.lighter',
                    borderColor: 'primary.dark'
                },
                border: '1px solid',
                borderColor: 'primary.main',
                bgcolor: 'background.paper',
                transition: 'all 0.2s'
            }}
            onClick={onClick}
        >
            <PersonOutlineIcon sx={{ fontSize: 20, color: 'primary.main' }} />
            <Typography
                sx={{
                    fontWeight: 500,
                    fontSize: 14,
                    color: 'primary.main'
                }}
            >
                {t('signIn')}
            </Typography>
        </Box>
    )
}

export { SignInButton }
export type { SignInButtonProps }
